import { Link, useLocation } from 'react-router-dom'
import { X } from 'lucide-react'
import { useLocale } from '../../i18n/LocaleContext'
import { navRoutes, getRegistrationPath } from '../../utils/routes'
import { getLocalizedPath, setPreferredLocale } from '../../utils/locale'

interface MobileMenuProps {
  open: boolean
  onClose: () => void
}

export default function MobileMenu({ open, onClose }: MobileMenuProps) {
  const { locale, t, otherLocale } = useLocale()
  const location = useLocation()
  const routes = navRoutes[locale]

  function handleLocaleSwitch() {
    setPreferredLocale(otherLocale)
    onClose()
  }

  return (
    <>
      {/* Backdrop */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-50 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Slide-in panel */}
      <div
        id="mobile-menu"
        role="dialog"
        aria-modal="true"
        aria-label={locale === 'hu' ? 'Menü' : 'Meniu'}
        className={`fixed top-0 right-0 h-full w-72 bg-white z-50 transform transition-transform duration-300 ease-out md:hidden ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border">
          <Link
            to={getLocalizedPath(location.pathname, otherLocale)}
            onClick={handleLocaleSwitch}
            className="text-sm font-medium text-text-secondary hover:text-primary transition-colors px-3 py-1.5 border border-border rounded-btn"
          >
            {otherLocale.toUpperCase()}
          </Link>
          <button onClick={onClose} className="p-2 text-secondary" aria-label={locale === 'hu' ? 'Menü bezárása' : 'Închide meniul'}>
            <X size={24} />
          </button>
        </div>

        {/* Nav links */}
        <nav className="flex flex-col p-4 gap-2">
          {routes.map((route) => (
            <Link
              key={route.path}
              to={route.path}
              onClick={onClose}
              className={`px-4 py-3 rounded-btn text-base font-medium transition-colors ${
                location.pathname === route.path
                  ? 'bg-accent text-primary'
                  : 'text-text-secondary hover:bg-surface'
              }`}
            >
              {t.nav[route.labelKey]}
            </Link>
          ))}
        </nav>

        {/* CTA */}
        <div className="p-4">
          <Link
            to={getRegistrationPath(locale)}
            onClick={onClose}
            className="block text-center bg-primary text-white px-5 py-3 rounded-btn font-medium hover:bg-primary-hover transition-colors"
          >
            {t.nav.cta}
          </Link>
        </div>
      </div>
    </>
  )
}
